import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg w-full max-w-md text-center text-text-white">
        <h2 className="text-5xl font-bold text-accent-red mb-4">403</h2>
        <h3 className="text-3xl font-semibold mb-4">Access Denied</h3>
        <p className="text-text-gray mb-6">
          You do not have the necessary permissions to view this page.
          Please contact your administrator if you believe this is an error.
        </p>
        <div className="flex justify-center">
          <Button
            onClick={() => navigate('/dashboard')}
            className="bg-accent-red hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;